import { render } from "./DataDownload.vue?vue&type=template&id=34007bce&scoped=true"
import script from "./DataDownload.vue?vue&type=script&lang=js"
export * from "./DataDownload.vue?vue&type=script&lang=js"

import "./DataDownload.vue?vue&type=style&index=0&id=34007bce&lang=scss&scoped=true"
import "./DataDownload.vue?vue&type=style&index=1&id=34007bce&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34007bce"]])

export default __exports__